import { cn } from '@woonstad/helpers-utils';
import clsx from 'clsx';

import { Typography } from '../typography/Typography';

type EnergyLabelProps = {
  type?: string | null;
};

export const EnergyLabel = ({ type }: EnergyLabelProps) => {
  const validTypes = ['A', 'A+', 'A++', 'A+++', 'A++++', 'A+++++', 'B', 'C', 'D', 'E', 'F', 'G'];

  if (!type || !validTypes.includes(type)) return null;

  const classes = clsx('z-10 flex h-[24px] min-w-[24px] items-center justify-center border-2 bg-[white] px-2',
    {
      'border-energyLabel-a text-energyLabel-a': type === 'A' || type === 'A+' || type === 'A++' || type === 'A+++' || type === 'A++++' || type === 'A+++++',
      'border-energyLabel-b text-energyLabel-b': type === 'B',
      'border-energyLabel-c text-energyLabel-c': type === 'C',
      'border-energyLabel-d text-energyLabel-d': type === 'D',
      'border-energyLabel-e text-energyLabel-e': type === 'E',
      'border-energyLabel-f text-energyLabel-f': type === 'F',
      'border-energyLabel-g text-energyLabel-g': type === 'G',
    });

  const arrowClasses = clsx('right-0 border-y-[12px] border-l-[9px] border-y-transparent',
    {
      'border-l-energyLabel-a': type === 'A' || type === 'A+' || type === 'A++' || type === 'A+++' || type === 'A++++' || type === 'A+++++',
      'border-l-energyLabel-b': type === 'B',
      'border-l-energyLabel-c': type === 'C',
      'border-l-energyLabel-d': type === 'D',
      'border-l-energyLabel-e': type === 'E',
      'border-l-energyLabel-f': type === 'F',
      'border-l-energyLabel-g': type === 'G',
    });

  const bgClasses = clsx('size-[1.5rem]',
    {
      'bg-energyLabel-a': type === 'A' || type === 'A+' || type === 'A++' || type === 'A+++' || type === 'A++++' || type === 'A+++++',
      'bg-energyLabel-b': type === 'B',
      'bg-energyLabel-c': type === 'C',
      'bg-energyLabel-d': type === 'D',
      'bg-energyLabel-e': type === 'E',
      'bg-energyLabel-f': type === 'F',
      'bg-energyLabel-g': type === 'G',
    });

  return (
    <span
      data-testid="energielabelValue"
      className="flex items-start"
    >
      <span className={classes}>
        <Typography
          variant="label-regular"
          type="span"
          // TODO: do we add a typography variant for this component?
          className="font-[700]"
        >
          {type}
        </Typography>
      </span>
      <span
        className={cn(bgClasses)}
      />
      <span className={arrowClasses} />
    </span>
  );
};
